import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {
    ChangeDeliveryPointComponent
} from "@app/presentation/pages/change-delivery-point/change-delivery-point.component";

const routes: Routes = [{ path: '', component: ChangeDeliveryPointComponent }];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class ChangeDeliveryPointRoutingModule { }